module.exports = __webpack_public_path__ + "img/20_dice[6].e19c2c44.png";